const TOOLTIP = {
    onReady() {
        document.addEventListener('click', TOOLTIP.close); 
    },
    /*********************
    * Must be handled over a document event listener because of xhr reloads
    *********************/
    close(event) {
        let close = event.target.closest('.tooltip__close');
        if (close !== null) {
            let tooltip = close.closest('.tooltip');
            tooltip.classList.remove('active');
        }
    }
}